import { NO_PRACTICE } from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';
import type { WorkCategoryAllSupported } from '@atlassian/jira-servicedesk-work-category/src/controllers/use-work-category-all-supported/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TicketTypeData, TicketType, TicketTypes } from '../../../common/types.tsx';

const setRequestTypesPractice =
	(ids: number[], practice: WorkCategoryAllSupported): Action<TicketTypeData> =>
	({ getState, setState }) => {
		const { ticketTypes } = getState();

		const practices = practice === NO_PRACTICE ? [] : [practice];

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const updatedRequestTypes: TicketTypes = ids.reduce<Record<string, any>>((acc, id) => {
			const requestType: TicketType = ticketTypes[String(id)].currentState;
			return {
				// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
				...acc,
				[String(id)]: {
					currentState: {
						...requestType,
						practices,
					},
					updateState: {},
				},
			};
		}, {});

		setState({
			ticketTypes: { ...ticketTypes, ...updatedRequestTypes },
		});
	};

export default setRequestTypesPractice;
